<header class="title-header pt-7 flex items-center justify-between">
  <div class="title-content flex items-center gap-2">
    <span class="material-symbols-outlined title-icon">hand_package</span>
    <h1 class="title-text">Proveedores</h1>
  </div>

  <!--Agregar proveedores-->
    <button class="add-button-top" (click)="openModal()">
    + Agregar proveedor
  </button>
</header>

<div class="mt-4 flex flex-wrap items-center justify-between bg-gray-50 p-3 rounded-lg shadow-sm">
  <p class="sub-heading-2">
    Total: {{ providers.length }} Proveedores
  </p>
    <div class="border border-gray-300 rounded-lg items-center px-3 py-2 bg-white">
    <button class="filter-button" (click)="showFilterModal = true">
      Filtrar
    <span class="material-symbols-outlined text-gray-900 font-medium">filter_alt</span>
    </button>
  </div>
</div>

<!--Tabla-->
<section class="p-6">
  <table class="w-full border-collapse bg-white rounded-xl shadow">
    <thead class="bg-gray-100 text-gray-900 text-sm">
      <tr>
        <th class="text-gray-800 text-left py-3 px-4">Nombre comercial</th>
        <th class="text-gray-800 text-left py-3 px-4">Email</th>
        <th class="text-gray-800 text-center py-3 px-4">RFC</th>
        <th class="text-gray-800 text-right py-3 px-4">Teléfono</th>
        <th class="text-gray-800 text-right py-3 px-4">Dirección</th>
        <th class="text-gray-800 text-right py-3 px-4">Estatus</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let b of providers" class="hover:bg-gray-50">
        <td class="py-3 px-4">{{ b.providerTradeName }}</td>
        <td class="py-3 px-4">{{ b.providerEmail }}</td>
        <td class="py-3 px-4">{{ b.providerRfc }}</td>
        <td class="py-3 px-4">{{ b.providerPhone }}</td>
        <td class="py-3 px-4">{{ b.providerAddress }}</td>
        <td
          class="py-3 px-4 text-center"
          [ngClass]="{
            'text-red-500': b.providerStatus === 'Inactivo',
            'text-green-600': b.providerStatus === 'Activo'
          }"
        >
          {{ b.providerStatus }}
        </td>
      </tr>

      <tr *ngIf="providers.length === 0">
        <td colspan="6" class="text-center py-6 text-gray-400">
          No hay facturas cargadas.
        </td>
      </tr>
    </tbody>
  </table>
</section>